<template>
  <div class="onboard-demo-notice">
    <transition name="fade">
      <div v-if="showDemoNotice" class="container deck-container live-demo m-b-50">
        <div class="notification has-text-centered is-primary is-light flex-row">
          <h2 class="title is-4 m-t-20 m-r-30"><span class="emoji">✨</span> Learn to host a Slides With Friends event in two minutes &rarr;</h2>
          <PlayDemoButton :tracking-data="{location: 'Decks Page Banner'}" class="is-medium">Play Live Demo</PlayDemoButton>
          <button @click="closeOnboarding()" class="delete" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import PlayDemoButton from '~/components/PlayDemoButton.vue'

export default {
  components: { PlayDemoButton },
  props: ['loading', 'slideDecks', 'user', 'hasAnyDecks'],
  data () {
    return {
      startedOnboarding: false,
      onboardingClosed: false,
      liveDemos: [
        { name: 'Meeting Icebreaker', deckId: 14391 }
        // { name: 'Team Building Game', deckId: 10375 },
        // { name: 'Competitive Trivia', deckId: 10375 },
        // { name: 'Live Word Cloud', deckId: 10375 },
        // { name: 'Poll or Survey', deckId: 10375 }
      ]
    }
  },
  computed: {
    showDemoNotice () {
      return !this.loading &&
             !this.onboardingClosed &&
             this.hasAnyDecks &&
             this.deckCount < 4 &&
             this.eventCount < 2 &&
             !this.hasOnboarded('onboard-demo-finished')
    },
    deckCount () {
      return this.slideDecks.length || this.user.slideDeckCount || 0
    },
    eventCount () {
      return this.user.event_count || 0
    }
  },
  mounted () {
    this.onboardingClosed = (Date.now() - this.$store.state.onboardingClosed < 86400000) // 24 hrs
  },
  methods: {
    closeOnboarding () {
      this.$store.commit('closeOnboarding')
      this.onboardingClosed = true

      if (window.Intercom) {
        window.Intercom('trackEvent', 'onboarding-closed')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.onboard-demo-notice {
  margin-top: -50px;

  .notification {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .is-primary.is-light {
    background-color: #fbe9f0; // override the default theme color to make it even lighter

    .title{
      color: var(--primary);
    }
  }
}
</style>
